import { formatValidQueryParamUrlCommaSeparated } from "utils/common";
import { sunoCommsApi } from "../api-base";
import type {
  LeadsSettings,
  LeadsSettingsInput
} from "../types/leads-settings.type";
import type { ServiceInterest } from "../types/service-interests.type";

export const leadsSettingsEndpoints = sunoCommsApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getLeadsSettings: builder.query<LeadsSettings, void>({
      query: () => "/lead-settings/",
      providesTags: ["LeadsSettings"]
    }),
    updateLeadsSettings: builder.mutation<LeadsSettings, LeadsSettingsInput>({
      query: (data: LeadsSettingsInput) => ({
        url: "/lead-settings/",
        method: "POST",
        body: data
      }),
      invalidatesTags: ["LeadsSettings"]
    }),
    getLeadsServiceInterests: builder.query<
      ServiceInterest[],
      { active?: boolean }
    >({
      query: (filter) =>
        `/service-interests/${formatValidQueryParamUrlCommaSeparated(
          filter,
          true
        )}`,
      providesTags: ["ServiceInterests"]
    }),
    createServiceInterest: builder.mutation<ServiceInterest, ServiceInterest>({
      query: (body) => ({
        url: `/service-interests/`,
        method: "POST",
        body
      }),
      invalidatesTags: ["ServiceInterests", "LeadsSettings"]
    }),
    updateServiceInterest: builder.mutation<ServiceInterest, ServiceInterest>({
      query: ({ id, ...body }) => ({
        url: `/service-interests/${id}`,
        method: "PATCH",
        body
      }),
      invalidatesTags: ["ServiceInterests", "LeadsSettings"]
    }),
    deleteServiceInterest: builder.mutation<void, string>({
      query: (id) => ({
        url: `/service-interests/${id}`,
        method: "DELETE"
      }),
      invalidatesTags: ["ServiceInterests", "LeadsSettings"]
    })
  })
});

export const {
  useGetLeadsSettingsQuery,
  useUpdateLeadsSettingsMutation,
  useGetLeadsServiceInterestsQuery,
  useCreateServiceInterestMutation,
  useUpdateServiceInterestMutation,
  useDeleteServiceInterestMutation
} = leadsSettingsEndpoints;
